<template>
    <form novalidate @submit.prevent="submit">
        <slot></slot>
    </form>
</template>

<script>
export default {
    props: {
        onSubmit: Function,
        onSuccess: Function, //  return promis available at promise Allow resubmission after completion
        onError: Function,
        register: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            disabled: false,
            vInputsMap: {},
            formData: {}
        };
    },
    provide() {
        return {
            setVmap: this.setVmap
        };
    },
    methods: {
        setVmap(key, vInput) {
            this.vInputsMap = Object.assign({}, this.vInputsMap, {
                [key]: vInput
            });
        },
        async submit() {
            if (this.disabled) {
                return; 
            }
            this.disabled = true;
            this.formData = {};
            const validConfig = await this.validate();
            this.onSubmit && this.onSubmit(this.$el, { ...this.formData });
            if (validConfig.valid) {
                let ps = this.onSuccess({ ...this.formData });
                if (ps instanceof Promise) {
                    return ps
                        .then(() => {
                            this.disabled = false;
                        })
                        .catch(e => {
                            this.disabled = false;
                            console.error(e)
                        });
                }
            } else {
                this.onError && this.onError(validConfig);
            }
            this.disabled = false;
        },
        async validate(silence) {
            const inputEles =
                this.inputEles || this.$el.querySelectorAll('[name]');
            let validConfig = {
                valid: true
            };
            let results = [];
            for (let i = 0, len = inputEles.length; i < len; i++) {
                const input = inputEles[i];
                const name = input.name;
                const type = input.type;
                if (type === 'radio' || type === 'checkbox') {
                    if (input.checked) {
                        this.formData[name] = input.value || '';
                    }
                } else {
                    this.formData[name] = input.value || '';
                }
                if (name && this.vInputsMap[name]) {
                    const result = await this.vInputsMap[name].validate(
                        silence
                    );
                    if (!result.valid) {
                        validConfig = {
                            valid: false,
                            msg: result.msg,
                            name: name,
                            el: input,
                            value: input.value || ''
                        };
                        // silence used to collect data
                        if (!silence) {
                            break;
                        } else {
                            results.push(validConfig);
                        }
                    }
                }
            }
            return silence ? results : validConfig;
        },
        reset(data) {
            Object.keys(data).forEach(key => {
                if (this.vInputsMap[key]) {
                    // vue3 修改 props 是 read only 报错
                    // this.vInputsMap[key].value = data[key];
                    this.vInputsMap[key].inputValue = data[key];
                }
            });
        },
        clear() {
            for (let k in this.vInputsMap) {
                this.vInputsMap[k].inputValue = ''
            }
        }
    }
};
</script>
